"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
// スキップボタンコンポーネント
exports.SituationSelectSkip = function (props) {
    var _a = react_1.useState(false), touching = _a[0], setTouching = _a[1];
    var onTouchStart = function () {
        setTouching(true);
    };
    var onTouchEnd = function () {
        setTouching(false);
    };
    return (React.createElement(Next, { onClick: props.onClickNext, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, touching: touching }, "\u30B9\u30AD\u30C3\u30D7"));
};
var Next = styled_components_1["default"].p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 120px;\n  height: 40px;\n  margin: auto;\n  line-height: 40px;\n  border: solid 1px #ddd;\n  font-size: 16px;\n  color: white;\n  background-color: ", ";\n"], ["\n  width: 120px;\n  height: 40px;\n  margin: auto;\n  line-height: 40px;\n  border: solid 1px #ddd;\n  font-size: 16px;\n  color: white;\n  background-color: ", ";\n"])), function (props) { return (props.touching ? "#fc9" : "orange"); });
var templateObject_1;
